const postorderTraversalProblems = [
  {
   title: "Binary Tree Postorder Traversal",
   url: "https://leetcode.com/problems/binary-tree-postorder-traversal/"
  },
  {
    title: "Maximum Depth of Binary Tree",
    url: "https://leetcode.com/problems/maximum-depth-of-binary-tree/"
  },
  {
    title: "Binary Tree Maximum Path Sum",
    url: "https://leetcode.com/problems/binary-tree-maximum-path-sum/"
  },
  {
    title: "Lowest Common Ancestor of a Binary Tree",
    url: "https://leetcode.com/problems/lowest-common-ancestor-of-a-binary-tree/"
  },
  {
    title: "Delete Nodes And Return Forest",
    url: "https://leetcode.com/problems/delete-nodes-and-return-forest/"
  }
];
export default postorderTraversalProblems;